import type { AdminFetchableRoles } from '@sine/sine-core-api-types';
import { type ISelectOption } from '@sine/sine-ui-components';

export enum RoleType {
  TeamOwner = 'TeamOwner',
  TeamAdmin = 'TeamAdmin',
  SiteAdmin = 'SiteAdmin',
  LobbyAdmin = 'LobbyAdmin',
  Reporting = 'Reporting',
  Reception = 'Reception',
}

// TODO: publish core-api-types and use `PermissionUsersGetReqBody`
export interface GetUsersBody {
  searchTerm?: string;
  roles?: Array<RoleType>;
  siteIds?: Array<string>;
}

// TODO: publish core-api-types and use `PermissionsAll`
export type PermissionsAll = 'All';
// TODO: publish core-api-types and use `PermissionsSiteIds`
export type PermissionsSiteIds = Array<string> | PermissionsAll;

export type RoleToSiteOptionsMap = Record<string, { role: AdminFetchableRoles; siteIds: Array<ISelectOption> }>;

export type EmailRoles = { role: string; siteCount?: number; isAll: boolean };
